//记得在 src\components\lang\zhLoad.js 里面添加对象
const qrCode = {
  msg: {
  }
};
export default qrCode



// WEBPACK FOOTER //
// ./src/page/bd/qc/qrCode/lang/index.en.js